import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Carousel } from "react-bootstrap";
import { Link } from "react-router-dom";
import defaultBanner from "../../Assets/defaultBanner.png";

const ImageSection = () => {
  const [groupedCarouselData, setGroupedCarouselData] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);
  const [currentIndex, setCurrentIndex] = useState(0);

  const getOfferMasterData = useSelector(
    (state) => state.offerMasterReducer?.getofferMaster
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 992);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    if (Array.isArray(getOfferMasterData)) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const enabledData = getOfferMasterData.filter((item) => {
        if (!item.enabled || item.placement !== "Middle") return false;
        const startDate = new Date(item.startDate);
        startDate.setHours(0, 0, 0, 0);
        const endDate = new Date(item.endDate);
        endDate.setHours(0, 0, 0, 0);
        return today >= startDate && today <= endDate;
      });
      const sortedData = [...enabledData].sort(
        (a, b) => parseInt(a.displayOrder) - parseInt(b.displayOrder)
      );
      const groupedData = [];
      const length = sortedData.length;

      for (let i = 0; i < length; i++) {
        const currentItem = sortedData[i];
        const nextItem = sortedData[(i + 1) % length];
        groupedData.push([currentItem, nextItem]);
      }
      setGroupedCarouselData(groupedData);
    }
  }, [getOfferMasterData]);

  const handleDotClick = (index) => {
    setCurrentIndex(index);
  };

  return (
    <>
      {groupedCarouselData?.length > 0 && (
        <div className="mainDiv" id="imageSection">
          <Carousel
            controls={false}
            interval={6000}
            activeIndex={currentIndex}
            onSelect={(selectedIndex) => setCurrentIndex(selectedIndex)}
          >
            {groupedCarouselData.map((pair, index) => (
              <Carousel.Item key={index}>
                <section className="py-xl-4 mt-0 pt-0 earn">
                  <div className="container">
                    <div className="row m-xl-n3 m-md-n2 m-n1 mt-4">
                      {pair
                        ?.sort((a, b) => a.displayOrder - b.displayOrder)
                        ?.map((offerMasterData, imgIndex) =>
                          (isMobile && imgIndex === 0) || !isMobile ? (
                            <div
                              className="col-lg-6 col-12"
                              key={`${index}-${imgIndex}`}
                            >
                              <div className="position-relative">
                                <Link to={offerMasterData?.link}>
                                  <img
                                    src={`${process.env.REACT_APP_CLIENT_URL}${offerMasterData?.image}`}
                                    alt={
                                      offerMasterData?.alt ||
                                      `Image ${imgIndex + 1}`
                                    }
                                    className="d-block w-100 imgSec_H"
                                    onError={(e) => {
                                      e.target.onerror = null;
                                      e.target.src = defaultBanner;
                                    }}
                                  />
                                </Link>
                              </div>
                            </div>
                          ) : null
                        )}
                    </div>
                  </div>
                </section>
              </Carousel.Item>
            ))}
          </Carousel>
          {((isMobile && groupedCarouselData?.length > 1) ||
            (!isMobile && groupedCarouselData?.length > 2)) && (
            <div className="dots-container">
              {groupedCarouselData.map((_, index) => (
                <div
                  key={index}
                  className={`dot1 ${index === currentIndex ? "active" : ""}`}
                  onClick={() => handleDotClick(index)}
                />
              ))}
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default ImageSection;
